import { create } from 'zustand';
import type { DesktopToolFlags, DesktopUserInfoData } from './types';

/**
 * Stav „desktopových" dat streamovaných z control iframu: info o přihlášeném uživateli (jméno,
 * helpdesk/logout URL, verze Magicu) a viditelnostní flags nástrojů. Plní ho `MagicControlBridge`
 * ze zpráv `desktop/user-info` a `desktop/tools-ready`. Logika nástrojů je ve Phoenixu.
 */
interface MagicDesktopStoreState {
  readonly userInfo: DesktopUserInfoData | null;
  readonly toolFlags: DesktopToolFlags | null;
  readonly setUserInfo: (info: DesktopUserInfoData) => void;
  readonly setToolFlags: (flags: DesktopToolFlags) => void;
  readonly reset: () => void;
}

export const useMagicDesktopStore = create<MagicDesktopStoreState>((set) => ({
  userInfo: null,
  toolFlags: null,
  setUserInfo: (userInfo) => set({ userInfo }),
  setToolFlags: (toolFlags) => set({ toolFlags }),
  reset: () => set({ userInfo: null, toolFlags: null }),
}));
